module.exports = __webpack_public_path__ + "img/icloud-drive.png";